import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment-timezone';
import { inject, observer } from 'mobx-react';
import { AxlPanel, AxlButton } from 'axl-reactjs-ui';
import { Box, IconButton, Tooltip } from '@material-ui/core';
import MapIcon from '@material-ui/icons/Map';

import EditIcon from '@material-ui/icons/Edit';

import ShipmentDropoffWhat3WordsInfo from '../ShipmentDropoffWhat3WordsInfo';
import DropoffInfoDialog from './DropoffInfoDialog';
import styles from './styles';
import { getCustomerProfile } from '../../stores/api';
import CorrectedValue from '../CorrectedValue';

@inject('userStore', 'shipmentStore')
@observer
class ShipmentDropoffInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      arrow: true,
      showPanel: this.props.isOpen,
      isOpenDropoffDialog: false,
      correctedInfo: null,
    };
  }

  componentDidMount() {
    if (this.props.arrow !== undefined) {
      this.setState({ arrow: this.props.arrow });
    }

    getCustomerProfile(this.props.shipment.id).then((res) => {
      const { shipment } = this.props;
      if (!res.ok) {
        this.setState({ correctedInfo: shipment?.dropoff_address });
        return;
      }

      this.setState({ correctedInfo: res.data?.corrected_address || shipment?.dropoff_address });
    });
  }

  formatDateTime(dt, timezone, withTz) {
    let format = '';
    const now = moment.tz(timezone).format('MM/DD/YYYY');
    const dateTime = moment.tz(dt, timezone).format('MM/DD/YYYY');

    if (now === dateTime) {
      format = 'hh:mm A';
    } else {
      format = 'MM/DD hh:mm A';
    }

    if (withTz) {
      format += ' z';
    }

    return moment.tz(dt, timezone).format(format);
  }

  render() {
    const { arrow, isOpenDropoffDialog, correctedInfo } = this.state;
    const { pickup, dropoff, shipment, userStore } = this.props;
    const COMPLETED = ['SUCCEEDED', 'FAILED'];
    const { blurCustomerAddress } = userStore;

    const dropoffStatus = dropoff && dropoff.status ? dropoff.status : null;

    const statusColor = dropoffStatus ? styles.Status[dropoffStatus] : styles.Status['DEFAULT'];
    const isHideEdit = shipment.dropoff_access_code || shipment.dropoff_additional_instruction;
    const isDisableAddNote = pickup && dropoff && !(COMPLETED.includes(dropoff.status) && pickup.status === 'SUCCEEDED');
    const { dropoff_address } = shipment;
    const originStreet = dropoff_address?.street || '';
    const originStreet2 = dropoff_address?.street2 || '';
    const originAddressLine2 = [dropoff_address?.city, dropoff_address?.state, dropoff_address?.zipcode].filter(Boolean).join(' ');
    const correctedStreet = correctedInfo?.street || '';
    const correctedStreet2 = correctedInfo?.street2 || '';
    const correctedAddressLine2 = [correctedInfo?.city, correctedInfo?.state, correctedInfo?.zipcode].filter(Boolean).join(' ');
    const correctedLatLng = [correctedInfo?.lat, correctedInfo?.lng].filter(Boolean).join(', ');
    const dropOffStatus = dropoff?.status === 'DISCARDED' ? 'EXCEPTION' : dropoff?.status;

    return (
      <AxlPanel style={styles.panelContainer}>
        <div style={styles.panelHeader}>
          <Box display="flex" flex={1} alignItems="center">
            <Box fontSize={14} fontWeight={700} fontFamily="AvenirNext">
              Dropoff Info:
            </Box>
            <Box ml={0.5} mt={-0.5}>
              <Tooltip title="Update Dropoff Info">
                <IconButton size="small" onClick={() => this.setState({ isOpenDropoffDialog: true })}>
                  <EditIcon fontSize="inherit" />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
          <div style={styles.panelHeaderRight}>
            <div style={styles.wrapHeaderEdit}>
              {dropoff && (
                <div
                  style={{
                    ...styles.panelHeaderStatus,
                    ...{ color: statusColor },
                  }}
                >
                  <span>
                    {dropOffStatus} {dropoff.actual_departure_ts && <span> @ {this.formatDateTime(dropoff.actual_departure_ts, moment.tz.guess())}</span>}
                  </span>
                </div>
              )}
              {!userStore.isReadOnly && (!dropoff || !COMPLETED.includes(dropoff.status)) && (!pickup || pickup.status !== 'FAILED') && (
                <div style={styles.panelHeaderButton}>
                  <AxlButton tiny bg={`white`} onClick={this.props.openForm('DropoffInfo')}>{`Edit`}</AxlButton>
                </div>
              )}
            </div>
            {arrow && (
              <div style={styles.panelHeaderArrow} onClick={() => this.setState({ showPanel: !this.state.showPanel })}>
                <i className={!this.state.showPanel ? 'fa fa-angle-down' : 'fa fa-angle-up'} />
              </div>
            )}
          </div>
        </div>
        {this.state.showPanel && (
          <AxlPanel.Row style={styles.panelContent}>
            <AxlPanel.Col flex={1}>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col>
                  <div style={styles.text}>
                    <Box>
                      <Box display="flex" alignItems="center">
                        <span>Address:</span>
                        <Tooltip arrow title="View on Google Maps">
                          <IconButton 
                            size="small" 
                            target="_blank" 
                            onClick={() => window.open(`https://google.com/maps/?q=${shipment?.dropoff_uncharted ? correctedLatLng : `${correctedStreet} ${correctedAddressLine2}`}`, '_blank', 'noopener,noreferrer')}
                          >
                            <MapIcon fontSize="inherit" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                      <CorrectedValue
                        originValue={originStreet}
                        correctedValue={correctedStreet}
                        blur={blurCustomerAddress}
                      />
                      <CorrectedValue
                        originValue={originStreet2} 
                        correctedValue={correctedStreet2}
                        blur={blurCustomerAddress}
                      />
                      <CorrectedValue
                        originValue={originAddressLine2}
                        correctedValue={correctedAddressLine2}
                      />
                    </Box>
                  </div>
                  <div style={{ fontSize: '9px' }}>
                    <span
                      style={{
                        padding: '0 1px',
                        color: 'green',
                        border: '1px solid green',
                        display: 'inline-block',
                      }}
                    >
                      {shipment.dropoff_navigation_difficulty}
                    </span>
                    &nbsp;&nbsp;
                    {shipment.dropoff_uncharted && (
                      <span
                        style={{
                          padding: '0 1px',
                          color: 'orangered',
                          border: '1px solid orangered',
                          display: 'inline-block',
                        }}
                      >
                        UNCHARTED
                      </span>
                    )}
                  </div>
                </AxlPanel.Col>
                {shipment.dropoff_note && (
                  <AxlPanel.Col>
                    <div style={styles.noteLabel}>{`NOTES`}</div>
                    <div style={styles.noteContent}>{shipment.dropoff_note}</div>
                  </AxlPanel.Col>
                )}
              </AxlPanel.Row>
              <ShipmentDropoffWhat3WordsInfo shipment={shipment} showLink={true} />
              <AxlPanel.Row>
                <AxlPanel.Col>
                  <AxlPanel.Row style={styles.timewindow}>
                    <div>
                      <AxlPanel.Col flex={1}>
                        <div style={styles.timeLabel}>
                          {`Time Window: `}
                          {shipment.dropoff_info_editable && shipment.timezone && (
                            <a style={styles.editButton} onClick={this.props.openForm('ShipmentTime')}>
                              Edit
                            </a>
                          )}
                        </div>
                        <div>
                          <div>
                            {this.formatDateTime(shipment.dropoff_earliest_ts, shipment.timezone)} - {this.formatDateTime(shipment.dropoff_latest_ts, shipment.timezone, true)}
                          </div>
                          {moment.tz.guess() !== shipment.timezone && (
                            <div>
                              {this.formatDateTime(shipment.dropoff_earliest_ts, moment.tz.guess())} - {this.formatDateTime(shipment.dropoff_latest_ts, moment.tz.guess(), true)}
                            </div>
                          )}
                        </div>
                      </AxlPanel.Col>
                    </div>
                  </AxlPanel.Row>
                  <AxlPanel.Row style={styles.timewindow}>
                    <AxlPanel.Col flex={1}>
                      <div style={styles.timeLabel}>{`ETA:`}</div>
                      <div>
                        {' '}
                        {dropoff && dropoff.predicted_departure_ts && (
                          <div>
                            <div>{this.formatDateTime(dropoff.predicted_departure_ts, shipment.timezone, true)}</div>
                            <div>{moment.tz.guess() !== shipment.timezone && this.formatDateTime(dropoff.predicted_departure_ts, moment.tz.guess(), true)}</div>
                          </div>
                        )}
                      </div>
                    </AxlPanel.Col>
                    {dropoff && dropoff.actual_departure_ts && (
                      <AxlPanel.Col flex={1}>
                        <div style={styles.timeLabel}>{`Actual Dropoff:`}</div>
                        <div>{this.formatDateTime(dropoff.actual_departure_ts, shipment.timezone, true)}</div>
                        <div>{moment.tz.guess() !== shipment.timezone && this.formatDateTime(dropoff.actual_departure_ts, moment.tz.guess(), true)}</div>
                      </AxlPanel.Col>
                    )}
                  </AxlPanel.Row>
                </AxlPanel.Col>
              </AxlPanel.Row>
              <AxlPanel.Row>
                <AxlPanel.Col flex={1}>
                  <div style={styles.dropoffRemarkContainer}>
                    <div
                      style={{
                        ...styles.dropoffRemarkHeader,
                        ...{ color: statusColor },
                      }}
                    >
                      <div style={styles.dropoffRemarkHeaderStatus}>{`DROPOFF REMARK`}</div>
                      <div style={styles.dropoffRemarkHeaderTime}>
                        {_.capitalize(dropoff ? dropOffStatus : '')} {dropoff && dropoff.actual_departure_ts && <span>@ {this.formatDateTime(dropoff.actual_departure_ts, moment.tz.guess())}</span>}
                      </div>
                    </div>
                    <div
                      style={{
                        ...styles.dropoffRemarkContent,
                        ...{ borderColor: statusColor },
                      }}
                    >
                      <div style={styles.dropoffRemarkContentText}>{dropoff && dropoff.remark ? dropoff.remark : '-'}</div>
                    </div>
                  </div>
                </AxlPanel.Col>
              </AxlPanel.Row>
              {/*do not show dispatch note*/}
              {false && (
                <AxlPanel.Row>
                  <AxlPanel.Col flex={1}>
                    <div style={styles.dropoffAccessContainer}>
                      <div style={styles.dropoffAccessContent}>
                        <div
                          style={{
                            ...styles.dropoffAccessContentText,
                            ...{ cursor: isHideEdit ? 'default' : 'pointer' },
                          }}
                        >
                          <div style={styles.dropoffAccessContentLabel}>
                            {shipment.dropoff_access_code ? (
                              <span>
                                {`Access code:`} <span style={{ color: '#000' }}>{shipment.dropoff_access_code}</span>
                              </span>
                            ) : shipment.dropoff_additional_instruction ? null : (
                              !userStore.isReadOnly && isDisableAddNote && <div onClick={this.props.openForm('AccessCode')}>{'+ Access Code / Additional Instruction'}</div>
                            )}
                          </div>
                        </div>
                        {!userStore.isReadOnly && isHideEdit && <AxlButton tiny bg={`white`} onClick={this.props.openForm('AccessCode')}>{`Edit`}</AxlButton>}
                      </div>
                      <div style={styles.dropoffAccessContentText}>
                        {shipment.dropoff_additional_instruction && (
                          <div style={styles.row}>
                            <span style={styles.dropoffAccessContentLabel}>{`Additional Instruction:`}</span>
                            <span>{shipment.dropoff_additional_instruction}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </AxlPanel.Col>
                </AxlPanel.Row>
              )}
            </AxlPanel.Col>
          </AxlPanel.Row>
        )}

        {isOpenDropoffDialog && (
          <DropoffInfoDialog isOpen={isOpenDropoffDialog} handleClose={() => this.setState({ isOpenDropoffDialog: false })} shipment={shipment} shipmentStore={this.props.shipmentStore} correctedInfo={correctedInfo} />
        )}
      </AxlPanel>
    );
  }
}

export default ShipmentDropoffInfo;
